<template>
  <TopNav></TopNav>
  <h1>Calculator de reduceri</h1>
  <fieldset>
    <legend>Calculator de reduceri</legend>
    <label for="a">Preț înainte de reducere:</label> <input type="number" v-model.number="initialPrice" id="a" step="any"> lei
    <br>
    <label for="b">Procent de reducere:</label> <input type="number" v-model.number="discountPercentage" id="b" step="any"> %
    <br><br>
    Preț după reducere: <span class="blue">{{ finalPrice() }} lei</span>
  </fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'

export default {
  name: "DiscountCalculator",
  data() {
    return {
      formatter: new Intl.NumberFormat('ro-RO', {
        maximumFractionDigits: 2
      }),
      initialPrice: 1000,
      discountPercentage: 15,
    }
  },
  components: {
    TopNav
  },
  methods: {
    finalPrice: function () {
      let result = this.initialPrice - (this.initialPrice * this.discountPercentage / 100);
      return this.formatter.format(result);
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

body {
  margin: 1em auto;
  margin-top: 0;
  max-width: 40em;
  font-family: Arial, Helvetica, sans-serif;
}

label {
  display: inline-block;
  min-width: 220px;
}

footer section a {
  margin: 20px;
}

.blue {
    color: blue;
}
</style>
